<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="800px"
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">Νέο Τιμολόγιο για S.{{ cid }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col
              cols="2"
            >
              <v-text-field
                label="ID"
                v-model="invoiceForm.Id"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="6" sm="4">
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateRangeText"
                  label="Ημερομηνία"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="invoiceForm.Date"
                @input="menu = false"
                :max="
                  new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                    .toISOString()
                    .substr(0, 10)
                "
              ></v-date-picker>
            </v-menu>
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-combobox
                label="Σειρά*"
                v-model="invoiceForm.SeriesCode"
                hint="Σειρά τιμολογίου"
                persistent-hint
                required
                :items="series"
                ></v-combobox>
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-text-field
                label="Αριθμός τιμολογίου"
                v-model="invoiceForm.DocNumber"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-select
                label="Τύπος Τιμολογίου*"
                :items="invoTypeItems"
                v-model="invoiceForm.InvoiceType"
                required
              >
              </v-select>
            </v-col>
            <v-col
              cols="6"
              sm="3"
            >
              <v-text-field
                label="Καθαρή αξία"
                v-model.number="invoiceForm.NetValue"
                type="number"
                required
              ></v-text-field>
            </v-col>
            <v-col
              cols="6"
              sm="3"
            >
              <v-text-field
                label="Aξία ΦΠΑ"
                v-model.number="invoiceForm.VatValue"
                readonly
              ></v-text-field>
              <v-select
                label="ΦΠΑ %"
                v-model="vat"
                :items="vatItems"
                append="%"
              ></v-select>
            </v-col>
            <v-col
              cols="6"
              sm="3"
            >
              <v-text-field
                label="Τελική Τιμή"
                v-model.number="invoiceForm.TotalValue"
                readonly
                required
              ></v-text-field>
            </v-col>
            <v-col cols="8"
                   sm="6">
              <v-select
                label="Τρόπος Πληρωμής*"
                v-model="invoiceForm.PaymTerm"
                :items="paymItems"
                required
              ></v-select>
            </v-col>
            <v-col cols="8"
                   sm="6">
              <v-select
                label="Kind*"
                v-model="invoiceForm.Kind"
                :items="kindItems"
                required
              ></v-select>
            </v-col>
            <v-col
              cols="12"
            >
              <v-text-field
                label="Remarks"
                v-model="invoiceForm.Remarks"
                hint="Σχόλια"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
            >
              <v-switch
                label="Δημιουργία πληρωμής"
                v-model="addPayment"
                :disabled="![1,3,4].includes(invoiceForm.PaymTerm)"
                hint="Σχόλια"
              ></v-switch>
            </v-col>
          </v-row>
        </v-container>
        <small>* Υποχρεωτικά πεδία</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          text
          @click="resetInvoice"
        >
          Εκκαθάριση
        </v-btn>
        <v-btn
          color="blue darken-1"
          text
          @click.native="close"
        >
          Κλεισιμο
        </v-btn>
        <v-btn
          color="blue darken-1"
          text
          :disabled="saveDisable"
          @click="createInvoice"
        >
          Αποθηκευση
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>

  export default {

   computed: {
      dateRangeText () {
        return new Date(this.invoiceForm.Date).toISOString().substr(0,10);
      },
    },
    props: {
        dialog: {
        default: false
      },
        cid: {
          required: true, default: 0
      },
    },
    data() {
      return {
        menu: false,
        series: [],
        saveDisable: false,
        addPayment: false,
        vat: 0.24,
        kindItems: [
          {text: 'Ανταλλακτικά', value: 0},
          {text: 'Αναλώσιμα', value: 1},
          {text: 'Βενζίνη', value: 2},
          {text: 'Τρόφιμα', value: 3},
          {text: 'Εργαλεία', value: 4},
        ],
        paymItems: [
          {text: "Κατάθεση σε τράπεζα", value: 1},
          {text: "Αντικαταβολή", value: 2},
          {text: "Μετρητά", value: 3},
          {text: "Επιταγή", value: 4},
          {text: "Επί Πιστώσει", value: 5},
          {text: "Web Banking", value: 6},
          {text: "POS / e-POS", value: 7},
       ],
        vatItems: [
          {text: '0', value: 0},
          {text: '6', value: 0.06},
          {text: '13', value: 0.13},
          {text: '24', value: 0.24},
       ],
        invoTypeItems: [
          {text: "Τιμολόγιο Πώλησης", value: '1.1'},
          {text: "Τιμολόγιο Παροχής Υπηρεσιών", value: '2.1'},
          {text: "Πιστωτικό Τιμολόγιο", value: '5.1'},
          {text: "Πιστωτικό Τιμολόγιο Μη Συσχετιζόμενο", value: '5.2'},
       ],
      invoiceForm: {
            Id: 0,
            SeriesCode: '',
            Docnumber: 0,
            InvoiceType: '1.1',
            Date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            Remarks: null,
            PaymTerm: 5,
            NetValue: 0,
            VatValue: 0,
            TotalValue: 0,
            Kind: 0
      },
        newInvoiceForm: {
          Id: null,
          SeriesCode: '',
          DocNumber: 0,
          InvoiceType: '1.1',
          Date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
          Remarks: null,
          PaymTerm: 5,
          NetValue: 0,
          VatValue: 0,
          TotalValue: 0,
          Kind: 0
       },
     }
    },
    watch: {
      'invoiceForm.NetValue' (newVal) {
        this.invoiceForm.VatValue = +((newVal * this.vat).toFixed(2));
        this.invoiceForm.TotalValue = Number((newVal + this.invoiceForm.VatValue).toFixed(2));

      },
      'vat' (newVal) {
        this.invoiceForm.VatValue = +((this.invoiceForm.NetValue * newVal).toFixed(2));
        this.invoiceForm.TotalValue = Number((this.invoiceForm.VatValue + this.invoiceForm.NetValue).toFixed(2));

      },
      cid: async function(newVal) {
        const response = await this.$api.get("/suppliers/"+newVal+"/invoices/series");
        this.series = response.data;
        this.invoiceForm.SeriesCode = this.series[0];
      }
    },

    async mounted() {
        if (this.cid) {
        const response = await this.$api.get("/suppliers/"+this.cid+"/invoices/series");
        this.series = response.data;
        this.invoiceForm.SeriesCode = this.series[0];
        }
    },
    methods: {
        close() {
        this.resetInvoice();
        this.$emit('update:dialog', false)
      },
      async createInvoice() {
        let invoice = this.invoiceForm;
        var response = await this.$api.post("/suppliers/"+this.cid+"/invoice/", invoice);
        if (response.status == 201) {
          this.invoiceForm.Id = response.data.Id;
          alert(`Νέο υπόλοιπο: ${response.data.Supplier.Balance.toFixed(2)}€`);
          this.saveDisable = true;
          if (this.addPayment){
            let payterm = 0
            if (this.invoiceForm.PaymTerm == 1) payterm = 1;
            if (this.invoiceForm.PaymTerm == 4) payterm = 3;
            response = await this.$api.post(`/suppliers/debits/${this.cid}`,
            {
              TotalValue: this.invoiceForm.TotalValue,
              Date: this.invoiceForm.Date,
              PaymTerm: payterm,
              Remarks: "Εξώφληση "+this.invoiceForm.SeriesCode+"-"+this.invoiceForm.DocNumber,

            });
            if (response.status == 201) {
            alert("Εξωφλήθη με κωδικό: "+response.data.Id);
            this.addPayment = false;
            }
          }
        } else {
          alert(response.data);
        }
      },
      resetInvoice() {
        Object.assign(this.invoiceForm, this.newInvoiceForm);
        this.saveDisable = false;
        this.addPayment = false;

      },
    },
  }

</script>
